import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramScheduledReminderFragment on ComplianceProgramScheduledReminderNode {
    id
    message
    daysAfterStartDate
    sentDatetime
    slackNotification
    emailNotification
    nominations
    oneonone
    performanceAssessment
    performanceSelfAssessment
    peerAssessment
    managerAssessment
    engagementSurvey
    remindedUsersCount
  }

  query getComplianceProgramScheduledReminders($complianceProgramId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      scheduledReminders {
        edges {
          node {
            ...ComplianceProgramScheduledReminderFragment
          }
        }
      }
    }
  }
`;
